import React, { Component } from "react";
import { I18n } from "react-redux-i18n";

// The normal ChatGPT page, a new chat. chatgpt.com does not allow to be embedded in a frame (X-Frame-Options and
// frame-ancestors), so it opens in a small floating browser window (popup) beside the app instead.
const CHATGPT_URL = "https://chatgpt.com/";
const PLUGIN_URL = "https://chatgpt.com/plugins/plugin_asdk_app_6ac391bd0d248191940ceba233a9efe0";
const WINDOW_NAME = "eatwithme-chatgpt";
const WIDTH = 440;
const HEIGHT = 720;

// TopBar (and with it this button) is mounted again on every navigation, so the window reference lives at module
// level. Otherwise a click after navigating would load the start page again and the running chat would be lost.
let popup = null;

// The MCP tools take the restaurant from their arguments and there is no server side session context, so the
// restaurant context is set by a prefilled first message (q parameter) that names the restaurant id and instance.
const currentInstance = () => (localStorage.instance && localStorage.instance !== "null" && localStorage.instance !== "undefined" ? localStorage.instance : "");

// The tools expect the global id of the restaurant as restaurantId, not the local database id (restaurantSelected).
const currentRestaurantId = () => {
  const globalId = localStorage.globalId;
  if (globalId && globalId !== "null" && globalId !== "undefined" && globalId !== "0") {
    return globalId;
  }
  return localStorage.restaurantSelected;
};

const buildUrl = () => {
  const id = currentRestaurantId();
  const name = localStorage.restaurantNameSelected;
  // the first part of the message: check that the EatWithMe plugin is installed and install it if it is not
  const pluginPrompt = I18n.t("admin_local.chatgpt_prompt_plugin", {
    link: PLUGIN_URL,
    defaultValue: "First check whether the EatWithMe plugin is installed. If it is not installed, install it with this link: " + PLUGIN_URL + "."
  });
  if (!id || id === "0" || id === "undefined" || !name) {
    return CHATGPT_URL + "?q=" + encodeURIComponent(pluginPrompt);
  }
  const instance = currentInstance();
  const defaultPrompt =
    'Set the working restaurant to "' + name + '" (restaurantId ' + id + (instance ? ", instance " + instance : "") + "). Use this restaurantId" + (instance ? " and instance" : "") + " in every EatWithMe tool call from now on and do not ask which restaurant to use.";
  const restaurantPrompt = I18n.t(instance ? "admin_local.chatgpt_prompt_instance" : "admin_local.chatgpt_prompt", { name: name, id: id, instance: instance, defaultValue: defaultPrompt });
  return CHATGPT_URL + "?q=" + encodeURIComponent(pluginPrompt + " " + restaurantPrompt);
};

export const openChatGpt = () => {
  // already open: only bring it to the front, never reload it (that would lose the running chat)
  if (popup && !popup.closed) {
    popup.focus();
    return;
  }
  const screenLeft = typeof window.screenX === "number" ? window.screenX : window.screenLeft || 0;
  const screenTop = typeof window.screenY === "number" ? window.screenY : window.screenTop || 0;
  const outerWidth = window.outerWidth || window.screen.width;
  const left = Math.max(0, screenLeft + outerWidth - WIDTH - 20);
  const top = Math.max(0, screenTop + 80);
  const features = "popup=yes,noopener=no,width=" + WIDTH + ",height=" + HEIGHT + ",left=" + left + ",top=" + top + ",resizable=yes,scrollbars=yes";
  // The window reference is lost when the app is reloaded, but the window may still be open. Looking it up by name
  // with an empty URL returns that window without navigating it; only a newly created window is blank.
  const win = window.open("", WINDOW_NAME, features);
  if (!win) {
    return; // blocked by the browser
  }
  let isNew = false;
  try {
    // an existing ChatGPT window is cross-origin and throws here, a new window is a same-origin about:blank
    isNew = win.location.href === "about:blank";
  } catch (e) {
    isNew = false;
  }
  if (isNew) {
    win.location.href = buildUrl();
  }
  popup = win;
  win.focus();
};

class ChatGptButton extends Component {
  render() {
    const title = I18n.t("admin_local.chatgpt_open", { defaultValue: "Open ChatGPT in a floating window" });
    const style = { paddingLeft: "4px", paddingRight: "4px", cursor: "pointer", display: "flex", alignItems: "center", color: "rgb(131, 123, 108)" };
    return (
      <div
        className="hide-print chatgpt-button-header"
        role="button"
        tabIndex={0}
        title={title}
        aria-label={title}
        onClick={openChatGpt}
        onKeyDown={e => (e.key === "Enter" || e.key === " ") && openChatGpt()}
        style={style}
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M21 11.5a8.5 8.5 0 0 1-12.4 7.6L3 20.5l1.4-5.1A8.5 8.5 0 1 1 21 11.5z" />
          <path d="M12 7.5l.9 2.6 2.6.9-2.6.9-.9 2.6-.9-2.6-2.6-.9 2.6-.9z" />
        </svg>
      </div>
    );
  }
}

export default ChatGptButton;
